import React, {
  lazy,
  useEffect,
  useRef,
  useState,
} from 'react'
import { ColumnsTable, HeaderActions, IClient, State } from 'safe'
import {
  fetchClients,
  createClient,
  updateClient,
  removeClient,
  onEnableClient,
  onUpdateCredit,
  deleteDocumentClient,
} from '../../redux/actions/clients'
import { connect, ConnectedProps } from 'react-redux'
import ClientAnimation from '../../assets/animations/client_animation.json'
import { AnimatePresence, motion } from 'framer-motion'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { HiDotsVertical } from 'react-icons/hi'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import axios from 'axios'
import {
  checkDoublePhones,
  formatter,
  getYearMonthAndDay,
} from '../../utils/utils'
import { FaArrowLeft } from 'react-icons/fa'
import pdfImage from '../../assets/images/pdf-icon-png-2082.png'
import docxImage from '../../assets/images/word-image.png'
import excelImage from '../../assets/images/excel-image.png'
import fileBlueImage from '../../assets/images/documents-image.png'
import DocumentAnimation from '../../assets/animations/empty_document.json'
import { HeaderProps } from '../../components/Layout/Header'
import addImage from '../../assets/images/add-image.png'

const Modal = lazy(() => import('../../components/Display/Modal'));
const ClientsForm = lazy(() => import('./ClientsForm'));
const Table = lazy(() => import('../../components/Display/Table'));
const Empty = lazy(() => import('../../components/Display/Empty'));
const FloatingMenu = lazy(() => import('../../components/Display/FloatingMenu'));
const ModalConfirm = lazy(() => import('../../components/Display/ModalConfirm'));
const CreateCreditForm = lazy(() => import('./CreateCreditModal'));
const ModalViewWithTabs = lazy(() => import('../../components/Display/ModalViewWithTabs'));
const Button = lazy(() => import('../../components/General/Button'));
const SearchFilter = lazy(() => import('./SearchFilter'));
const FloatingForm = lazy(() => import('../../components/Display/FloatingForm'));
const AdvancedClientsForm = lazy(() => import('../../components/Display/AdvancedClientsForm'));

const Clients: React.FC<ClientsProps & PropsFromRedux> = ({
  clients,
  numberOfPages,
  setHeaderActions,
  fetchClients,
  createClient,
  updateClient,
  removeClient,
  onEnableClient,
  onUpdateCredit,
  deleteDocumentClient,
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [createModal, setCreateModal] = useState<boolean>(false)
  const [searchModal, setSearchModal] = useState<boolean>(false)
  const [modalFromRow, setModalFromRow] = useState(false)
  const [confirmModal, setConfirmModal] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])
  const [fastSearch, setFastSearch] = useState<string>('')

  const [currentPage, setCurrentPage] = useState<number>(0)
  const [clientToDelete, setClientToDelete] = useState<object>({})

  const [selected, setSelected] = useState<any>(null)
  const [menuVisible, setMenuVisible] = useState<number>(-1)
  const [showCreditModal, setShowCreditModal] = useState<boolean>(false)
  const { addAlert } = useSnackBars()
  const [userConfig] = useLocalStorageState('user-config')

  /* Notas de credito */
  const [onShowCreditNote, setOnShowCreditNote] = useState<boolean>(false)
  const [creditNotes, setCreditNotes] = useState<any[]>([])
  const [
    numberOfPagesCreditHistoric,
    setNumberOfPagesCreditHistoric,
  ] = useState<number>(1)
  const [
    currentPageCreditHistoric,
    setCurrentPageCreditHistoric,
  ] = useState<number>(0)
  const [displaySearchFilter, setDisplaySearchFilter] = useState<boolean>(false)
  const [searchParamsCreditNotes, setSearchParamsCreditNotes] = useState<
    string[]
  >([])

  const [showDocuments, setShowDocuments] = useState<boolean>(false)

  const [selectedDocument, setSelectedDocument] = useState<any | null>(null)

  const server = process.env.REACT_APP_SERVER_URL

  const refInputSearch = useRef<HTMLInputElement | null>(null)

  // const getClients = useCallback(async () => {
  //   setLoading(true)
  //   await fetchClients(searchParams, [
  //     `pageNumber=${currentPage + 1}`,
  //     `pageSize=${userConfig.rowsPerPage}`,
  //   ])
  //   setLoading(false)
  // }, [currentPage])

  const getClients = async (
    params: string[] = searchParams,
    pageNumber: number = 0,
    fastParam = fastSearch
  ) => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    setFastSearch(fastParam)

    setCurrentPage(pageNumber)

    setSearchParams(params)

    setLoading(true)

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    await fetchClients(newParams, paginationParams)
    setLoading(false)
  }

  const getCreditNotes = async (
    client,
    params = searchParamsCreditNotes
  ): Promise<void> => {
    setLoading(true)
    let response = await axios.get(
      `${server}/thirdparty/credit/client/${client.id}?pageNumber=${
        currentPageCreditHistoric + 1
      }&pageSize=${userConfig.rowsPerPage}&${params.join('&')}`
    )
    setLoading(false)
    setNumberOfPagesCreditHistoric(response.data.numberOfPages)
    setCreditNotes(response.data.credits)
    setDisplaySearchFilter(false)
  }

  useEffect(() => {
    getClients()
  }, [])

  useEffect(() => {
    if (onShowCreditNote) {
      getCreditNotes(selected)
    }
  }, [currentPageCreditHistoric])

  const onFilterFloatingOptions = (options, client) => {
    return options
    if (client.enable) return options
    return {
      onEnable: async () => {
        addAlert({ message: 'Habilitando cliente...', status: 'loading' })
        try {
          await onEnableClient(client.id, true)
          addAlert({
            message: 'Cliente habilitado con exito',
            status: 'success',
          })
          setMenuVisible(-1)
        } catch (err) {
          addAlert({ message: 'Error al habilitar cliente', status: 'error' })
        }
      },
    }
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      render: (name: any, client: any) => (
        <ColumnItemWrapper>
          <div className="flex">
            {/* {!client.enable && (
              <AiOutlineWarning
                style={{ marginRight: '4px' }}
                className="text-yellow-300"
              />
            )} */}
            {client?.document?.documentType === 'J' ||
            client?.document?.documentType === 'C'
              ? client?.businessName
              : client?.name}
          </div>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Teléfono',
      dataIndex: 'phone',
      key: 'phone',
      width: 170,
      render: (x: any, client: any) => {
        if (!client?.phone1 || client?.phone1?.includes("null")) return ""
        return (
        <ColumnItemWrapper>
          <div
            style={{
              whiteSpace: 'pre',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {/* {
              client?.phones
                .map((phone) => {
                  // console.log('phone: ', phone)
                  return phone.number ? `${phone.country.dial_code || phone.country.dialCode} ${phone.number}` : 'N/A'

                })
                .join('\n')} */}
            {client?.phone1 && client?.phone
              ? [`+${client.phone1}`, `+${client.phone2}`].join('\n')
              : `+${client?.phone1}`}
          </div>
        </ColumnItemWrapper>
        )
    },
    },
    {
      title: 'Documento',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, client: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {client?.documentType}-{client?.document}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Dirección',
      dataIndex: 'address',
      key: 'address',
      render: (x: any, client: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {[client?.city, client?.state, client?.postalCode].join(', ')}
        </ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Credito',
    //   dataIndex: 'credit',
    //   key: 'credit',
    // },
    {
      title: 'Correo',
      dataIndex: 'email',
      key: 'email',
      render: (mail) => (
        <ColumnItemWrapper subElement="paragraph">
          {mail ? mail : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, client: any) => (
        <ColumnItemWrapper floatingMenu>
          <FloatingMenu
            visible={id === menuVisible}
            onClose={() => setMenuVisible(-1)}
            options={onFilterFloatingOptions(
              {
                onEdit: () => {
                  setCreateModal(true)
                  setSelected(client)
                },
                onDelete: async () => {
                  setConfirmModal(true)
                  setClientToDelete(client)
                },
                onSendWhatsappMessage: async () => {
                  const [left, right] = client?.phone1?.split(' ')

                  let number = `${left}${right}`

                  if (/^0/.test(right)) {
                    number = `${left}${right.slice(1)}`
                  }

                  let response = await axios.get(`${server}/config/tenant`)

                  let text = response?.data?.userConf?.whatsappGreeting

                  if (text) {
                    window.open(
                      `https://api.whatsapp.com/send?phone=${number}&text=${text}`,
                      '_blank'
                    )
                  } else {
                    window.open(
                      `https://api.whatsapp.com/send?phone=${number}`,
                      '_blank'
                    )
                  }
                },
                // onCredit: () => {
                //   setShowCreditModal(true)
                //   setSelected(client)
                // },
                // onDisable: async () => {
                //   addAlert({
                //     message: 'Deshabilitando cliente...',
                //     status: 'loading',
                //   })
                //   try {
                //     await onEnableClient(client.id, false)
                //     addAlert({
                //       message: 'Cliente deshabilitado con éxito',
                //       status: 'success',
                //     })
                //     setMenuVisible(-1)
                //   } catch (err) {
                //     addAlert({
                //       message: 'Error al deshabilitar cliente',
                //       status: 'error',
                //     })
                //   }
                // },
                // onCreditNote: async () => {
                //   setSelected(client)
                //   getCreditNotes(client)
                //   // let response = await axios.get(
                //   //   `${server}/thirdparty/credit/client/${client.id}`
                //   // )
                //   // setCreditNotes(response.data.credits)
                //   setOnShowCreditNote(true)
                // },
                // onFiles: () => {
                //   setSelected(client)
                //   setShowDocuments(true)
                // },
              },
              client
            )}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={() => setMenuVisible(id)}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  const columnsTableCreditNote: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatter(record?.createdAt)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record.type === 'ARBITRARY' ? 'Arbitrario' : 'Nota de crédito'}
        </ColumnItemWrapper>
      ),
    },
  ]

  const getOrderKeys = (key: string) => {
    if (key === 'document') return ['document', 'document']
    if (key === 'address') return ['address', 'street']
    if (key === 'phone') return ['phones', '0', 'number']
    return [key]
  }

  const filterHeader = (header) => {
    console.log('onshow credit note', onShowCreditNote)
    if (onShowCreditNote)
      return {
        searchAction: () => setDisplaySearchFilter(true),
        cleanFilters: header.cleanFilters,
      }
    return header
  }

  useEffect(() => {
    setHeaderActions(
      filterHeader({
        addAction: () => setCreateModal(true),
        // searchAction: () => setSearchModal(true),
        advancedSearch: async (value) => {
          if (typeof value === 'boolean') {
            setSearchModal(value)
            return
          }
          getClients(searchParams, 0, value)
          // setSearchParams([`fastSearch=${value}`])
          // if (currentPage === 0) {
          //   fetchClients(
          //     [`fastSearch=${value}`],
          //     [
          //       `pageNumber=${currentPage + 1}`,
          //       `pageSize=${userConfig.rowsPerPage}`,
          //     ]
          //   )
          // } else {
          //   setCurrentPage(0)
          // }
        },
        // onSearch: {
        //   action: (value) => {
        //     let valueWithoutSpaces = value.replace(/\s{2,}/g, " ").trim()
        //     fetchClients(
        //       [`value=${valueWithoutSpaces}`],
        //       [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
        //     )
        //   },
        //   placeholder: "Buscar. Ej: V88888888",
        //   display: true,
        //   ref: refInputSearch,
        //   tooltipMessage: "Puede buscar por documento, correo y nombre y apellidos o razón social"
        // },
        cleanFilters: {
          sort: () => {
            console.log('sort clean')
          },
          search: async () => {
            if (onShowCreditNote) {
              setSearchParamsCreditNotes([])
              if (currentPageCreditHistoric === 0) {
                getCreditNotes(selected, [])
              }
              setCurrentPageCreditHistoric(0)
            } else {
              getClients([], 0)
              // setSearchParams([])
              // if (currentPage === 0) {
              //   setLoading(true)
              //   await fetchClients(
              //     [],
              //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
              //   )
              //   setLoading(false)
              // }
              // setCurrentPage(0)
            }
          },
          isSearch: onShowCreditNote
            ? Boolean(searchParamsCreditNotes.length > 0)
            : Boolean(searchParams.length > 0),
        },
      })
    )
    return () => {
      if (refInputSearch && refInputSearch.current) {
        refInputSearch.current.value = ''
        refInputSearch.current = null
      }
      setHeaderActions(null)
    }
  }, [
    currentPage,
    fetchClients,
    searchParams,
    setHeaderActions,
    userConfig.rowsPerPage,
    onShowCreditNote,
    searchParamsCreditNotes,
    onShowCreditNote,
    currentPageCreditHistoric,
  ])

  const onDelete = async (values) => {
    const _values: IClient = {
      ...values,
    }
    setLoading(true)
    try {
      addAlert({ message: 'Eliminando cliente...', status: 'loading' })
      await removeClient(_values)
      addAlert({ message: 'Cliente eliminado con éxito', status: 'success' })
    } catch (e: any) {
      let response = e?.response?.data?.message
      if (response.includes('associated accounting records')) {
        addAlert({
          message:
            'No se puede eliminar este cliente porque tiene registros contables asociados.',
          status: 'error',
        })
      } else {
        console.log('Error delete', e.response.data)
        addAlert({ message: 'Error al eliminar cliente', status: 'error' })
      }
    } finally {
      setLoading(false)
    }
  }

  const deleteClient = async () => {
    setConfirmModal(false)
    await onDelete(clientToDelete)
    try {
      getClients([], 0)
      // if (currentPage === 0) {
      //   setSearchParams([])
      //   setLoading(true)
      //   await fetchClients(
      //     [],
      //     [
      //       `pageNumber=${currentPage + 1}`,
      //       `pageSize=${userConfig.rowsPerPage}`,
      //     ]
      //   )
      //   setLoading(false)
      // } else {
      //   setCurrentPage(0)
      // }
    } catch (err: any) {
      addAlert({
        message: err?.response?.data?.message || 'Server Error',
        status: 'error',
      })
    }
  }

  const pressRow = (client) => {
    console.log('client...', client)
    let clientDetails = ''
    clientDetails += `Documento: ${client.documentType}-${client.document}\n`
    client.documentType.match(/([V]|[E]|[G]|[P])/) &&
      (clientDetails += `Nombre y apellido: ${client.name}\n`)
    // client.documentType.match(/([V]|[E]|[G]|[P])/) &&
    //   (clientDetails += `Apellidos: ${client.surname}\n`)
    client.documentType.match(/([J]|[C])/) &&
      (clientDetails += `Razón Social: ${client.businessName}\n`)
    client.email && (clientDetails += `Correo: ${client.email}\n`)
    client.address.street &&
      (clientDetails += `Calle: ${client.address.street}\n`)
    client.address.avenue &&
      (clientDetails += `Avenida: ${client.address.avenue}\n`)
    client.address.building &&
      (clientDetails += `Edificio: ${client.address.building}\n`)
    client.address.neighborhood &&
      (clientDetails += `Sector: ${client.address.neighborhood}\n`)
    clientDetails += `Ciudad: ${client.address.city}\n`
    clientDetails += `Estado: ${client.address.state}\n`
    // clientDetails += `País: ${client.address.country}\n`
    clientDetails += `Código Postal: ${client.address.postalCode}\n`
    // clientDetails += `Telefonos: ${client.address.postalCode}\n`

    // clientDetails += `Código Postal: ${client.address.postalCode}\n`

    // for (let i = 0; i < client.phones.length; i++) {
    //   if (i === 0) {
    //     clientDetails += `Telefonos:  ${client.phones[i].country.dialCode || client.phones[i].country.dial_code} ${client.phones[i].number}\n`
    //   } else {
    //     clientDetails += `\t\t\t${client.phones[i].country.dialCode || client.phones[i].country.dial_code} ${client.phones[i].number}\n`
    //   }
    // }
    setSelected(clientDetails)
    // // setModal(true)
    setModalFromRow(true)
  }

  const onSubmitToastValue = (message: string, status: string): void => {
    addAlert({ message, status })
  }

  const onSubmit = async (values) => {
    // toUpperValues(values)

    console.log(JSON.stringify(values, null, 2))
    const fd = new FormData()
    // setLoading(true)
    try {
      if (!values.id) {
        console.log('llegando..')
        console.log('val', values)
        addAlert({ message: 'Creando cliente...', status: 'loading' })
        const { phones, ...rest } = values
        const [phone1, phone2] = phones
        const _values: { newClient: Omit<IClient, 'id'> } = {
          ...rest,
          phone_1: `${phone1?.country?.id} ${phone1?.number || null}`,
          phone_2: phone2 ? `${phone2?.country?.id} ${phone2?.number}` : null,
        }

        console.log('_values', _values)

        let checkDouble = checkDoublePhones(phones)

        if (checkDouble) {
          addAlert({
            message: 'Número telefónico ya existente',
            status: 'error',
          })
        } else {
          if (values.clientFile) {
            fd.append('media', values.clientFile)
            fd.append('fileType', 'pdf')
            try {
              await createClient(_values, true, fd)
              addAlert({
                message: 'Imagen y cliente creados satisfactoriamente',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al subir imagen o crear cliente',
                status: 'error',
              })
            }
            getClients([], 0)

            // if (currentPage === 0) {
            //   setLoading(true)
            //   fetchClients(
            //     [],
            //     [
            //       `pageNumber=${currentPage + 1}`,
            //       `pageSize=${userConfig.rowsPerPage}`,
            //     ]
            //   )
            //   setLoading(false)
            // } else {
            //   setCurrentPage(0)
            // }
            // setSearchParams([])
            // setCreateModal(false)
          } else {
            let checkDouble = checkDoublePhones(phones)

            if (checkDouble) {
              addAlert({
                message: 'Número telefónico ya existente',
                status: 'error',
              })
            } else {
              console.log('llega...')
              await createClient(_values)
              setSearchParams([])
              /** Se hace el setCurrent para que se ejecute el useEffect y realice una nueva peticion */
              // if (currentPage === 0) {
              //   fetchClients(
              //     [],
              //     [
              //       `pageNumber=${currentPage + 1}`,
              //       `pageSize=${userConfig.rowsPerPage}`,
              //     ]
              //   )
              // } else {
              //   setCurrentPage(0)
              // }
              getClients([], 0)

              addAlert({
                message: 'Cliente creado con éxito',
                status: 'success',
              })
              setCreateModal(false)
            }
          }
        }
      } else {
        if (values.clientFile) {
          fd.append('media', values.clientFile)
          fd.append('fileType', 'pdf')
          addAlert({ message: 'Actualizando cliente...', status: 'loading' })
          const _values: { client: IClient } = {
            client: {
              ...values,
            },
          }
          // let checkDouble = checkDoublePhones(_values.client.phones)
          // if (checkDouble) {
          //   addAlert({
          //     message: 'Número telefónico ya existente',
          //     status: 'error',
          //   })
          // } else {
          //   await updateClient(_values, true, fd)
          //   addAlert({
          //     message: 'Cliente actualizado con éxito',
          //     status: 'success',
          //   })
          //   setCreateModal(false)
          // }
        } else {
          addAlert({ message: 'Actualizando cliente...', status: 'loading' })
          const { phones, ...rest } = values
          console.log('phones', phones)
          const [phone1, phone2] = phones
          const _values: { client: IClient } = {
            ...rest,
            phone_1: `${phone1?.country?.id} ${phone1?.number || null}`,
            phone_2: phone2
              ? `${phone2?.country?.id} ${phone2?.number || null}`
              : null,
          }

          let checkDouble = checkDoublePhones(phones)
          if (checkDouble) {
            addAlert({
              message: 'Número telefónico ya existente',
              status: 'error',
            })
          } else {
            // if (!_values.client.phone_1) {
            //   delete _values.client.phone_1
            // }

            // if (!_values.client.phone_2) {
            //   delete _values.client.phone_2
            // }

          await updateClient(_values)
            setSearchParams([])
            /** Se hace el setCurrent para que se ejecute el useEffect y realice una nueva peticion */
            // if (currentPage === 0) {
            //   fetchClients(
            //     [],
            //     [
            //       `pageNumber=${currentPage + 1}`,
            //       `pageSize=${userConfig.rowsPerPage}`,
            //     ]
            //   )
            // } else {
            //   setCurrentPage(0)
            // }
            getClients([], 0)

            await addAlert({
              message: 'Cliente actualizado con éxito',
              status: 'success',
            })
            setCreateModal(false)
          }
        }
      }
    } catch (e: any) {
      // console.log('Error de client', e.response.error)
      // if ()
      addAlert({
        message: 'Error al crear o actualizar cliente',
        status: 'error',
      })
      console.log('E', e)
      setCreateModal(false)
    } finally {
      setLoading(false)
      setSelected(null)
    }
  }

  const onSubmitCreditForm = async (values) => {
    let valuesSubmit = {
      ...values,
      credit: +values.credit,
    }

    addAlert({ message: 'Guardando crédito...', status: 'loading' })
    try {
      await onUpdateCredit(selected && selected.id, valuesSubmit)
      addAlert({ message: 'Crédito guardado', status: 'success' })
      setShowCreditModal(false)
      setSelected(null)
    } catch (err: any) {
      addAlert({ message: err.response.data.message, status: 'error' })
    }
  }

  const onSubmitSearchFilter = async (values) => {
    const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(values.from)

    const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.to)

    values.from = new Date(yearFrom, monthFrom, dayFrom)
    values.to = new Date(yearTo, monthTo, dayTo + 1)

    let params = Object.keys(values).map(
      (key) => `${key}=${values[key].toISOString()}`
    )
    setSearchParamsCreditNotes(params)
    if (currentPageCreditHistoric === 0) {
      await getCreditNotes(selected, params)
      setCurrentPageCreditHistoric(0)
    } else {
      setCurrentPageCreditHistoric(0)
    }
  }

  // const returnNameByRegex = (url: string): string => {
  //   let getTypeFolder = (url.match(/\/client\/.+\//g) || [])[0].split('/')[2]
  //   let regexValue = `((?<=\\/${getTypeFolder}\\/).+)(?=\\.)`
  //   console.log('get type', regexValue)
  //   let newNameRegex = new RegExp(regexValue, 'g')
  //   let name = (url.match(newNameRegex) || [])[0]
  //   return name
  // }

  const handleFileInput = (file) => {
    let fileBody = file.target.files[0]
    const params = {
      ACL: 'public-read',
      Body: fileBody,
      // Bucket: S3_BUCKET,
      Key: fileBody.name,
    }

    // myBucket.putObject(params)
    // .on('httpUploadProgress', (evt) => {
    //     setProgress(Math.round((evt.loaded / evt.total) * 100))
    // })
    // .send((err) => {
    //     if (err) console.log(err)
    // })
  }

  return (
    <>
      <AnimatePresence>
        {clients?.length === 0 && !onShowCreditNote && (
          <Empty
            animationProps={{
              height: 400,
              width: 400,
              animation: ClientAnimation,
            }}
            lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
          >
            <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
              Los clientes son claves para tu negocio, añadelos y empieza a
              vender.{' '}
            </p>
          </Empty>
        )}
        {clients?.length > 0 && !onShowCreditNote && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Table
              data={clients}
              columns={columns}
              loading={loading}
              pages={numberOfPages}
              pageSelected={currentPage}
              setLoading={setLoading}
              setPageSelected={(page) => getClients(searchParams, page)}
              getOrderKeys={getOrderKeys}
              onPressButton={pressRow}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {onShowCreditNote && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="flex flex-row mb-3">
            <Button
              classes="border-none"
              onClick={() => {
                setOnShowCreditNote(false)
                setMenuVisible(-1)
                setCurrentPageCreditHistoric(0)
                setSearchParamsCreditNotes([])
              }}
              type="arrow"
              warehouseType="WAREHOUSE"
            >
              <FaArrowLeft size={30} />
            </Button>
          </div>

          <Table
            data={creditNotes}
            columns={columnsTableCreditNote}
            loading={loading}
            pages={numberOfPagesCreditHistoric}
            pageSelected={currentPageCreditHistoric}
            setLoading={setLoading}
            setPageSelected={setCurrentPageCreditHistoric}
            getOrderKeys={getOrderKeys}
          />
        </motion.div>
      )}

      <Modal
        display={createModal}
        // modalClasses="w-3/6 py-4 px-12 overflow-scroll"
        onAccept={() => null}
        scroll="scroll"
        onClose={() => {
          setCreateModal(false)
          setSelected(null)
        }}
      >
        <ClientsForm
          useType={selected === null ? 'create' : 'edit'}
          onSubmit={onSubmit}
          defaultValues={selected}
          onCancel={() => {
            setCreateModal(false)
            setSelected(null)
          }}
        />
      </Modal>

      <ModalViewWithTabs
        display={modalFromRow}
        onClose={() => {
          setModalFromRow(false)
          setSelected(null)
        }}
        dataWithTabs={[{ title: 'Cliente', data: selected }]}
      />

      {/* <Modal
        display={searchModal}
        // modalClasses="w-2/5 py-4 px-8"
        scroll="visible"
        onAccept={() => null}
        onClose={() => {
          setSearchModal(false)
        }}
      >
        <SearchClientsForms
          setSearchModal={setSearchModal}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setLoading={setLoading}
        ></SearchClientsForms>
      </Modal> */}

      <FloatingForm
        visible={searchModal}
        onClose={() => setSearchModal(false)}
        topClass="top-16"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        {/* <SearchClientsForms
          setSearchModal={setSearchModal}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setLoading={setLoading}
        ></SearchClientsForms> */}
        <AdvancedClientsForm
          onCloseAdvancedForm={() => setSearchModal(false)}
          type="CLIENTS"
          onSubmit={async (values) => {
            let params = Object.keys(values).reduce((a, b) => {
              if (values[b] !== '') {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            // setSearchParams(params)

            getClients(params, 0)

            // if (currentPage === 0) {
            //   setLoading(true)
            //   await fetchClients(params, [
            //     `pageNumber=${currentPage + 1}`,
            //     `pageSize=${userConfig.rowsPerPage}`,
            //   ])
            //   setLoading(false)
            //   setSearchModal(false)
            // } else {
            //   setCurrentPage(0)
            // }
          }}
        />
      </FloatingForm>

      <ModalConfirm
        title="¿Está seguro que desea eliminar el cliente?"
        displayConfirmModal={confirmModal}
        onCancel={() => setConfirmModal(false)}
        onConfirm={deleteClient}
      />

      <Modal
        display={showCreditModal}
        // modalClasses="w-2/5 py-4 px-8"
        scroll="visible"
        onAccept={() => null}
        onClose={() => {
          setShowCreditModal(false)
        }}
        xlClasses="xl:w-4/12"
      >
        <CreateCreditForm
          onSubmit={onSubmitCreditForm}
          onCancel={() => setShowCreditModal(false)}
          defaultValues={selected}
          useType={'create'}
        />
      </Modal>

      <Modal
        display={displaySearchFilter}
        onClose={() => setDisplaySearchFilter(false)}
      >
        <SearchFilter
          onSubmit={onSubmitSearchFilter}
          onClose={() => setDisplaySearchFilter(false)}
        />
      </Modal>

      <Modal
        display={showDocuments}
        onAccept={() => null}
        onClose={() => {
          setShowDocuments(false)
          setSelected(null)
        }}
      >
        <h1 className="text-center mb-2">Documentos</h1>
        <div className="grid grid-cols-3">
          {selected &&
            selected?.documents &&
            [...selected?.documents, { url: addImage }]?.map(
              (document, idx) => (
                <div
                  className={`shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex flex-col relative m-auto ${
                    idx < selected?.documents.length
                      ? 'dark:bg-gray-800'
                      : 'cursor-pointer'
                  } w-2/3`}
                >
                  <img
                    src={
                      idx === selected?.documents.length
                        ? document.url
                        : document.url.endsWith('.docx')
                        ? docxImage
                        : document.url.endsWith('pdf')
                        ? pdfImage
                        : document.url.endsWith('xlsx')
                        ? excelImage
                        : fileBlueImage
                    }
                    alt="imageUpload"
                    className={`h-28 object-contain ${
                      idx < selected?.documents.length && 'rounded-3xl'
                    } dark:border-gray-700`}
                  />
                  <div className="flex flex-row justify-between items-center mt-2">
                    <div>
                      <h1
                        style={{
                          maxWidth: '105px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        className="text-sm"
                      >
                        {/* {idx === selected?.documents.length
                          ? 'Agregar'
                          : returnNameByRegex(document.url)} */}
                      </h1>
                    </div>

                    {idx < selected?.documents.length && (
                      <FloatingMenu
                        onClose={() => {
                          setSelectedDocument(null)
                        }}
                        visible={document.id === selectedDocument}
                        options={{
                          onDelete: async () => {
                            try {
                              addAlert({
                                message: 'Eliminando documento...',
                                status: 'loading',
                              })
                              await deleteDocumentClient(
                                document.id,
                                document.url.replace(/https:\/\//, ''),
                                selected.id
                              )
                              addAlert({
                                message: 'Documento eliminado con éxito',
                                status: 'success',
                              })
                            } catch (err) {
                              addAlert({
                                message: 'Error al eliminar documento',
                                status: 'error',
                              })
                            }
                          },
                          onDownload: () => window.open(`${document.url}`),
                        }}
                      >
                        <HiDotsVertical
                          className="cursor-pointer text-gray-400"
                          onClick={() => setSelectedDocument(document.id)}
                        />
                      </FloatingMenu>
                    )}
                    <input type="file" onChange={handleFileInput} />
                  </div>
                </div>
              )
            )}

          {selected?.documents?.length === 0 && (
            <div className="col-span-5">
              <Empty
                animationProps={{
                  animation: DocumentAnimation,
                  width: 350,
                  height: 350,
                }}
              >
                <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                  No hay documentos, añadelos.
                </p>
              </Empty>
            </div>
          )}
        </div>
      </Modal>
    </>
  )
}

const mapState = ({ clie }: State) => ({
  clients: clie.clients,
  numberOfPages: clie.numberOfPages,
})

const connector = connect(mapState, {
  fetchClients,
  createClient,
  updateClient,
  removeClient,
  onEnableClient,
  onUpdateCredit,
  deleteDocumentClient,
})

export default connector(Clients)
type PropsFromRedux = ConnectedProps<typeof connector>

interface ClientsProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}
